import React from 'react';
import { Form, Field } from 'react-final-form';

import { CONFIRM_ALERT } from '../../../../../constants';

const credentials = props => (
    <Form onSubmit={props.testflight} initialValues={{email: props.userEmail, code: props.companyCode}} render={({handleSubmit, submitting, pristine, values}) => (
        <form onSubmit={handleSubmit} autoComplete="false">
            <div className="form-group form-material floating" data-plugin="formMaterial">
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="icon ti-email" aria-hidden="true"></i></span>
                    </div>
                    <div className="form-control-wrap">
                        <Field type="email" name="email" className="form-control empty" id="email" component="input" required />
                        <label className="floating-label" htmlFor="email">Your email</label>
                    </div>
                </div>
            </div>
            <div className="form-group form-material floating" data-plugin="formMaterial">
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="icon ti-lock" aria-hidden="true"></i></span>
                    </div>
                    <div className="form-control-wrap">
                        <Field type="text" name="code" className="form-control empty" component="input" required />
                        <label className="floating-label">Code</label>
                    </div>
                </div>
            </div>
            <div className="form-group">
                <button type="submit" className="btn btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic" disabled={submitting || pristine} style={{width: '49%'}}>
                    <span><i className="icon ti-check" aria-hidden="true"></i>&nbsp;Submit</span>
                </button>
                &nbsp;
                <button type="button" className="btn btn-animate btn-animate-vertical btn-danger btn-sm waves-effect waves-classic" disabled={submitting} onClick={CONFIRM_ALERT.bind(this, 'Cancel', 'Cancel password reset?', () => window.location.href = "/")} style={{width: '49%'}}>
                    <span><i className="icon ti-close" aria-hidden="true"></i>&nbsp;Cancel</span>
                </button>
            </div>
            {props.passwordChanged && (
                <a className="float-center" href='/'>
                    <i className="icon fa-sign-in" aria-hidden="true"></i>&nbsp;Sign in
                </a>
            )}
            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
        </form>
    )}/>
);

export default credentials;